'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormat = getFormat;
exports.getAverageWaitTime = getAverageWaitTime;
exports.getDifferenceInDaysToNow = getDifferenceInDaysToNow;
exports.getDifferenceInHoursToNow = getDifferenceInHoursToNow;
exports.getDifferenceInMinutesToNow = getDifferenceInMinutesToNow;
exports.getDifferenceInMinutes = getDifferenceInMinutes;
exports.getDifferenceInSecondsToNow = getDifferenceInSecondsToNow;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFormat(abbreviateMonth, includeTime, timeOnly) {
  return !timeOnly ? 'D MMM' + (abbreviateMonth ? '' : 'M') + ' YYYY' + (includeTime ? ', h:mm a' : '') : 'h:mm a';
}

function getAverageWaitTime(val) {
  var retval = '--';
  if (val) {
    if (val < 60 && val !== 0) {
      retval = val > 1 ? val + ' mins' : val + ' min';
    }

    if (val > 60 && val < 1440) {
      var hrs = Math.round(val / 60);
      retval = hrs > 1 ? hrs + ' hours' : hrs + ' hour';
    }

    if (val >= 1440) {
      var days = Math.floor(val / 1440);
      retval = days > 1 ? days + ' days' : days + ' day';
    }
  }
  return retval;
}

function getDifferenceInDaysToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asDays());
}

function getDifferenceInHoursToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asHours());
}

function getDifferenceInMinutesToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asMinutes());
}

function getDifferenceInMinutes(startTime, endTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(_moment2.default.unix(endTime));
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asMinutes() > 1 ? duration.asMinutes() : 1);
}

function getDifferenceInSecondsToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return duration.asSeconds();
}